<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
}
</script>

<style>
.app-container {
  width: 1920px;
}
@font-face {
  font-family: 'PangMenZhengDao';
  src: url('@/assets/fonts/PangMenZhengDaoBiaoTiTi-1.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'PingFang SC';
  src: url('@/assets/fonts/PingFang Medium.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
</style>
